import { Component, ErrorInfo, ReactNode } from 'react';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { Result, Button } from 'antd';
import { withTranslation } from 'react-i18next';
import { config, isProductionStage } from 'config';

if (isProductionStage(config.STAGE)) {
  Sentry.init({
    dsn: 'https://e6d27050505075e84df3b95873f5c158@o4506564489969664.ingest.sentry.io/4506564492066816',
    integrations: [new Integrations.BrowserTracing()],
    environment: window.location.host,
    enabled: import.meta.env.MODE === 'production',

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    release: config.npm_package_version,
    ignoreErrors: [
      /ResizeObserver/,
      /getBoundingClientRect/,
      /chrome-extension:\/\//
    ],
    normalizeDepth: 6
  });
}

interface Props {
  t: (key: string) => string;
  children: ReactNode;
}

class CatchError extends Component<Props, { hasError: boolean }> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, errorInfo: ErrorInfo) {
    if (import.meta.env.MODE === 'production') {
      Sentry.withScope((scope) => {
        scope.setExtras({ stack: errorInfo.componentStack });
        Sentry.captureException(error);
      });
    }
  }

  render() {
    const { t, children } = this.props;
    const { hasError } = this.state;
    if (hasError) {
      return (
        <div
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center'
          }}
        >
          <Result
            status="500"
            title={t('title')}
            subTitle={t('description')}
            extra={
              <Button onClick={() => window.history.back()}>{t('back')}</Button>
            }
          />
        </div>
      );
    }
    return children;
  }
}

export default withTranslation('error')(
  import.meta.env.MODE !== 'production'
    ? ({ children }) => <>{children}</>
    : CatchError
);
